module.exports = __webpack_public_path__ + "img/ABRAZADERA DOBLE.b88a3417.jpg";